var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"items-center",attrs:{"no-gutters":"","id":""}},[_vm._t("title",function(){return [_c('div',{staticClass:"title-class",class:_vm.titleClass},[_vm._v(" "+_vm._s(_vm.title)+" ")])]}),_c('div',{staticClass:"app_divider"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }